(() => {
  if (window.PreaProductGridLoadMore) {
    window.PreaProductGridLoadMore.init(document);
    return;
  }

  const GRID_SELECTOR = '[data-prea-product-grid]';

  const initGrid = (grid) => {
    if (!grid || grid.dataset.preaLoadMoreReady === 'true') return;

    const section = grid.closest('[data-prea-best-sellers-section], [data-prea-new-arrivals-section]');
    const button = section?.querySelector('[data-prea-load-more-button]');
    const control = button?.closest('[data-prea-load-more-control]');
    const status = section?.querySelector('[data-prea-load-more-status]');
    const items = Array.from(grid.children).filter((item) => item.classList.contains('prea-product-card-wrapper'));
    const mobileInitialCount = Math.max(1, Number(grid.dataset.initialCount) || 6);
    const desktopInitialCount = Math.max(1, Number(grid.dataset.initialCountDesktop) || mobileInitialCount);
    const desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    const getInitialCount = () => desktopMediaQuery.matches ? desktopInitialCount : mobileInitialCount;
    const batchSize = Math.max(1, Number(grid.dataset.batchSize) || 6);
    let hasLoadedMore = false;

    grid.dataset.preaLoadMoreReady = 'true';
    items.slice(0, getInitialCount()).forEach((item) => item.classList.add('is-load-more-visible'));

    if (!button) {
      if (control) control.hidden = true;
      return;
    }

    const visibleCount = () => items.filter((item) => item.classList.contains('is-load-more-visible')).length;
    const updateControl = () => {
      const count = visibleCount();
      const hasMore = count < items.length;
      button.setAttribute('aria-expanded', String(!hasMore));
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (control) control.hidden = !hasMore;
      if (status) status.textContent = `Showing ${count} of ${items.length} products.`;
    };

    button.addEventListener('click', () => {
      const nextItems = items
        .filter((item) => !item.classList.contains('is-load-more-visible'))
        .slice(0, batchSize);

      if (!nextItems.length) {
        updateControl();
        return;
      }

      hasLoadedMore = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      nextItems.forEach((item, index) => {
        item.style.setProperty('--prea-load-more-index', String(index));
        item.classList.add('is-load-more-visible', 'is-load-more-revealing');
        item.addEventListener('animationend', () => {
          item.classList.remove('is-load-more-revealing');
          item.style.removeProperty('--prea-load-more-index');
        }, { once: true });
      });

      window.setTimeout(updateControl, 70 * Math.max(nextItems.length - 1, 0) + 680);
    });

    const syncInitialCount = () => {
      if (hasLoadedMore) return;

      const initialCount = getInitialCount();
      items.forEach((item, index) => {
        item.classList.toggle('is-load-more-visible', index < initialCount);
      });
      updateControl();
    };

    desktopMediaQuery.addEventListener?.('change', syncInitialCount);

    updateControl();
  };

  const initAll = (root = document) => {
    if (root.matches?.(GRID_SELECTOR)) initGrid(root);
    root.querySelectorAll?.(GRID_SELECTOR).forEach(initGrid);
  };

  window.PreaProductGridLoadMore = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
